<template>
 <div>
    <div class="nav">
      <div class="nav-logo" v-if="contentNav == false && listNav == false">
        <img src="../../../assets/logo-nav.png">
      </div>
      <div class="nav-logo" v-if="contentNav == true && listNav == false" style="line-height: 50px;font-size: 30px;color:#FFECB2" @click="goToPrevPage()">
        <van-icon name="arrow-left"  />
      </div>
      <div class="nav-logo" v-if="listNav == true" style="line-height: 50px;font-size: 30px;">
        <router-link :to="{name:'HomeYjj'}" style="color:#FFECB2">
          <van-icon name="arrow-left"  />
        </router-link>

      </div>
      <div class="nav-title">
        <h3>东北抗日义勇军纪念馆</h3>
      </div>
      <div class="nav-more">
        <van-icon  name="wap-nav" @click="showPopup" />
      </div>
    </div>
   <van-popup class="left-nav" v-model="show" position="top">
    <ul class="left-nav-list">
      <li><router-link :to="{name:'HomeYjj',params:{nav:'shouye'}}">首页</router-link></li>
      <li><router-link :to="{name:'intro',params:{nav:'jianjie'}}">馆内简介</router-link></li>
      <li><router-link :to="{name:'NewsListYjj',params:{nav:'jianjie'}}">资讯动态</router-link></li>
      <li><router-link :to="{name:'DisplayListYjj',params:{nav:'jianjie'}}">陈列展览</router-link></li>
      <li><router-link :to="{name:'CulturalListYjj',params:{nav:'jianjie'}}">馆藏文物</router-link></li>
      <li><router-link :to="{name:'ResearchListYjj',params:{nav:'yanjiu'}}">学术研究</router-link></li>
      <li><router-link :to="{name:'MemoryYjj',params:{nav:'yinglie'}}">缅怀英烈</router-link></li>
    </ul>
   </van-popup>
 </div>
</template>

<script>

export default {
  name: "HeaderYjjM",
  data() {
    return {
      show: false,
      contentNav:false,
      prevNav:'',
      listNav:false,
      listNavName:[
          "NewsListYjj","MapYjj","intro","DisplayListYjj","CulturalListYjj","ResearchListYjj","MemoryYjj"
      ]
    };
  },
  methods: {
    showPopup() {
      this.show = true;
    },
    isContent(){

      if(this.$router.history.current.name == "ArticleContentYjj"){
        this.listNav = false;
        this.contentNav = true;
      }
      for (var i = 0 ;i<this.listNavName.length;i++){
        if(this.listNavName[i] == this.$router.history.current.name){
          this.contentNav = false;
          this.listNav = true;

        }
      }
    },
    savePrevNav(){
      if(this.$route.params.prevNav){
        this.prevNav = this.$route.params.prevNav;
        localStorage.setItem('prevNav', this.prevNav);
      }
    },
    goToPrevPage(){
      var backData = localStorage.getItem('prevNav');
      this.prevNav = backData;
      this.$router.push({name:this.prevNav});

    }
  },
  mounted() {
    this.savePrevNav();
    this.isContent();
  }

}
</script>

<style scoped>
.nav{
  height:50px;
  background-color: #9E1A28;
  display: flex;
}
.nav-logo,.nav-more{
  max-height: 50px;
  overflow: hidden;
  text-align: center;
}
.nav-more{
  flex: 1;
}
.nav-logo{
  flex: 1;
}
.nav-logo img{
  width:100%;
  height: 45px;
  margin-top: 5px;
}
.nav-title{
  line-height: 50px;
  color:#FFECB2;
  flex: 3;
}

.nav-more{
  font-size: 25px;
  color:#FFECB2;
  line-height: 50px;


}
.left-nav{

  width: 50%;
  background: #9E1A28;
  height:100%;
}
.left-nav-list{
  padding-top: 50px;
}
.left-nav-list li{
  font-size: 18px;
  line-height: 60px;
  color: white;
  border-bottom: 1px rgba(255,255,255,0.2) solid;
}
.left-nav-list li a{
  color: white;
}
</style>
